'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _calendarThead = require('./calendar-thead');

var _calendarThead2 = _interopRequireDefault(_calendarThead);

var _calendarTbody = require('./calendar-tbody');

var _calendarTbody2 = _interopRequireDefault(_calendarTbody);

var _calendarMixin = require('../calendar-mixin');

var _calendarMixin2 = _interopRequireDefault(_calendarMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarTable = function (_Component) {
    (0, _inherits3.default)(CalendarTable, _Component);

    function CalendarTable(props) {
        (0, _classCallCheck3.default)(this, CalendarTable);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CalendarTable.__proto__ || (0, _getPrototypeOf2.default)(CalendarTable)).call(this, props));

        _this.state = {
            value: props.value,
            base: props.base,
            mode: props.mode
        };
        return _this;
    }

    (0, _createClass3.default)(CalendarTable, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ('value' in newProps) {
                this.setState({
                    value: newProps.value
                });
            }

            if ('base' in newProps) {
                this.setState({
                    base: newProps.base
                });
            }

            if ('mode' in newProps) {
                this.setState({
                    mode: newProps.mode
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                prefix = _props.prefix,
                onChange = _props.onChange,
                others = (0, _objectWithoutProperties3.default)(_props, ['prefix', 'onChange']);
            var type = others.type;
            var _state = this.state,
                value = _state.value,
                base = _state.base,
                mode = _state.mode;


            var tableCls = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, prefix + 'calendar-table', true), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-' + mode + '-table', mode), (0, _defineProperty3.default)(_classNames, prefix + 'calendar-' + type + '-table', type), _classNames));

            return _react2.default.createElement(
                'table',
                { className: tableCls, ref: 'calendar-table' },
                mode === 'month' ? _react2.default.createElement(_calendarThead2.default, (0, _extends3.default)({}, this.props, { value: value })) : null,
                _react2.default.createElement(_calendarTbody2.default, (0, _extends3.default)({}, others, { base: base, value: value, mode: mode, onChange: onChange }))
            );
        }
    }]);
    return CalendarTable;
}(_react.Component);

CalendarTable.propTypes = {
    type: _propTypes2.default.oneOf(['fullscreen', 'card']),
    onChange: _propTypes2.default.func,
    selectWeek: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool])
};


(0, _calendarMixin2.default)(CalendarTable);

exports.default = CalendarTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-calendar-ex@0.0.4@@alicd/crui-calendar-ex/lib/view/table/calendar-table.js
// module id = 150
// module chunks = 0